import React, { Component } from 'react';
import { Modal, Button, Table, Form, Input, Divider, message,Icon } from 'antd';
import './schoolAmbassador.less'
import axios from '../../service/index'
import * as XLSX from 'xlsx';


class LabelManagement extends Component {

	constructor(props) {
		super(props)
		this.state = {
			visible: false,
      visibleUpload: false,
      showUpload: 'before',
			buttonList:[],
      msgObj: 0,
      fileObj: {},
      iconLoading: false,
			lableListData: [],
			name: '',
			phone: '',
			total: 0,
			labelPhone:"",
			searchData: {
				pageNum: 1,
				pageSize: 10,
			},
			labelName: '',
			Id: "",
			labelId: null,
			modelTitle: '新建标签',
			columns: [
				{
					title: '姓名',
					dataIndex: 'name',
					key: 'name',
					align: 'center'
				},
				{
					title: '电话',
					dataIndex: 'phone',
					key: 'phone',
					align: 'center'
				},
				{
					title: '积分',
					dataIndex: 'integral',
					key: 'integral',
					align: 'center'
				},
				{
					title: '操作',
					key: 'operation',
					align: 'center',
					render: (record) => <div>
            { this.state.buttonList.some(item => item.perms === 'api:integral:getIntegralList') ? <span style={{ marginRight: '15px', color: '#277FFF', cursor: 'pointer' }} onClick={() => {
							this.props.history.push('/IntegralDetails',{ subtractionUserId: record.userId})
						}}>积分详情</span> : "" }
						{ this.state.buttonList.some(item => item.perms === 'api:integral:updateAmbassador') ?<span style={{ marginRight: '15px', color: '#277FFF', cursor: 'pointer' }} onClick={() => {
							this.setState({
								visible: true,
								labelName: record.name,
								labelPhone: record.phone,
								modelTitle: '编辑大使',
								Id: record.id
							})
						}}>编辑</span>: ""}
					</div>
				},
			]
		}
	}
	componentDidMount() {
		this.setState({
			buttonList:JSON.parse(localStorage.getItem('buttonList')) || []
		})
		
		this.lableList()
	}
  componentWillUnmount() {
    this.setState({msgObj: 0, formdataObj: {}})
		
  }
  // 文件上传-上传前
   beforeUpload = (file, fileList) => {
    if (file.size / 1024 / 1024 /1024> 1) {
      return message.error('不允许超过1G!');
    }
    this.setState({iconLoading: true})
  }
  resetChoose = () => {
    this.setState({showUpload: 'before',fileObj: {}, formdataObj: {}})
  }
	showModal = (e) => {
		this.setState({
			modelTitle: '新增大使',
			visible: true
		})
	}
  uploadFile = (e) => {
    this.setState({
			modelTitle: '批量导入',
			visibleUpload: true
		})
  }
  uploadCardImgFront = (file) => {
    const { files } = file.target;
        // 通过FileReader对象读取文件
        const fileReader = new FileReader();
        fileReader.onload = event => {
            try {
                const { result } = event.target;
                // 以二进制流方式读取得到整份excel表格对象
                const workbook = XLSX.read(result, { type: 'binary' });
                // 存储获取到的数据
                let data = [];
                // 遍历每张工作表进行读取（这里默认只读取第一张表）
                for (const sheet in workbook.Sheets) {
                    // esline-disable-next-line
                    if (workbook.Sheets.hasOwnProperty(sheet)) {
                        // 利用 sheet_to_json 方法将 excel 转成 json 数据
                        data = data.concat(XLSX.utils.sheet_to_json(workbook.Sheets[sheet]));
                        // break; // 如果只取第一张表，就取消注释这行
                    }
                }
                // 最终获取到并且格式化后的 json 数据
               // message.success('上传成功！')
								axios.post('integralController/addCampusAmbassador',
									data
								).then(res=> {
									// console.log(res)
									if(res.data.code === '200'){
										// message.success('上传成功！')
										this.setState({showUpload: 'reset',msgObj: res.data.msg})
										this.lableList()
										this.setState({
											visible: false
										})
									}else {
										message.error(res.data.msg)
									}
								})
            } catch (e) {
                // 这里可以抛出文件类型错误不正确的相关提示
                message.error('文件类型不正确！');
            }
        };
        // 以二进制方式打开文件
        fileReader.readAsBinaryString(files[0]);
				// fileReader.readAsText(files[0],'utf-8')
  }

	handleOk = (e) => {
		this.props.form.validateFields((err, values) => {
			console.log(err, values)
			if (!err) {
				if(this.state.modelTitle === '新增大使'){
					axios.post('integralController/addCampusAmbassador',
						[{name: values.name,phone: values.phone}]
					).then(res=> {
						if(res.data.code === '200'){
							message.success('添加成功')
							this.lableList()
							this.setState({
								visible: false
							})
						}else {
							message.error(res.data.msg)
						}
					})
				}else {
					axios.post('integralController/updateAmbassador',{
						name: values.name,
						phone: values.phone,
						id: this.state.Id
					}).then(res=> {
						// console.log(res)
						if(res.data.code === '200'){
							message.success('编辑成功')
							this.lableList()
							this.setState({
								visible: false
							})
						}else {
							message.error(res.data.msg)
						}
					})
				}
				
			}
		})
	}
	lableList = () => {
		axios.post('integralController/getAmbassadorList', {
			...this.state.searchData,
			phone: this.state.phone
		}).then(res => {
			if (res.data.code === '200') {
				this.setState({
					lableListData: res.data.data.list,
					total: res.data.data.total,
					searchData: {
						pageSize: res.data.data.pageSize,
						pageNum: res.data.data.pageNum,
					}
				})

			}
		})
	}
	delLable(id) {
		axios.get(`labelController/del/${id}`).then( res => {
			if(res.data.code === '200'){
				message.success('删除成功')
				this.lableList()
			}else {
				message.error(res.data.msg)
			}
		})
	}
	handleCancel = () => {
		this.setState({
			visible: false,
      visibleUpload: false
		})
	};
  offModal = () => {
    this.setState({visibleUpload: false, showUpload: 'before'},() => {
      // this.InitQuestionList()
    })
  }
	//下载错误文件
	downerrfile = () => {
		axios.get('integralController/exportFailList',{responseType: 'blob'}).then(res=> {
			const link = document.createElement('a')
            let blob = new Blob([res.data], { type: 'application/vnd.ms-excel' })
            link.style.display = 'none'
            link.href = URL.createObjectURL(blob)
            link.setAttribute('download', '校园大使错误列表.xlsx')
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
		})
	}
	render() {
		const { lableListData, modelTitle, columns, visible,visibleUpload,showUpload,iconLoading,msgObj, labelName,labelPhone, total,buttonList } = this.state
		const { getFieldDecorator } = this.props.form;
		const pagination ={
			showSizeChanger: true,
			total: total,
			pageSizeOptions: ['10', '20', '30', '40'],
			showTotal:() => `共 ${total} 条`,
			onShowSizeChange: (current,pageSize) => {
				let searchData = this.state.searchData
				searchData.pageNum = current
				searchData.pageSize = pageSize
				this.lableList(searchData)
			},
			onChange: (current) => {
				let searchData = this.state.searchData
				searchData.pageNum = current
				this.lableList(searchData)
			},
		}
		return (
			<div>
				<span style={{ display: 'flex', alignItems: 'center', fontSize: '18px', fontWeight: '600' }}>校园大使</span>
				<Divider />
				<div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
					<div>
						<Input allowClear value={this.state.phone} style={{ width: '260px', height: '40px', marginRight: '20px' }} 
						placeholder="请输入手机号"
						onChange={(e)=>{
							this.setState({
								phone: e.target.value
							})
						}}
						></Input>
						<Button className='my-button-primary' type='primary' onClick={() => {
							this.lableList()
						}}>搜索</Button>
						<span className='my-button-txt' style={{marginLeft: '20px'}} type='primary' onClick={() => {
							this.setState({
								phone: ''
							},()=>{
								this.lableList()
							})
						}}>重置</span>
					</div>
          <div>
					 { buttonList.some(item => item.perms === 'api:integral:addCampusAmbassador') ? <Button className='my-button-primary' style={{ marginRight: '20px', marginBottom: '20px' }} type='primary' onClick={(e) => {
							this.showModal(e)	
							}}>新增大使</Button> : "" } 
						 { buttonList.some(item => item.perms === 'api:integral:addCampusAmbassador') ? <Button className='my-button-primary' type='primary' onClick={(e) => { 
							this.uploadFile(e)
						 }}>批量导入</Button> : "" } 
					</div>
				</div>
				<Table dataSource={lableListData} columns={columns} rowKey={record => record.userId} rowClassName={(record, index) => (index % 2 !== 0 ? 'table-line' : '')} pagination={pagination}/>
				<Modal
					getContainer={true}
					title={modelTitle}
					okText="确认"
					cancelText="取消"
					visible={visible}
					onOk={() => { this.handleOk() }}
					onCancel={() => { this.setState({ visible: false }) }}
					destroyOnClose
					maskClosable={false}
					
				>
					<Form labelCol={{ span: 5 }} wrapperCol={{ span: 18 }} onSubmit={this.handleOk}>
						<Form.Item label={"姓名"}>
							{getFieldDecorator('name', {
								rules: [{ required: true, message: '请输入姓名!'},{max: 50, message: '最多输入50个字符'}],
								initialValue:modelTitle==='编辑大使'? labelName: ''
							})(
								<Input placeholder='请输入姓名' />
							)}
						</Form.Item>
            <Form.Item label={"电话号码"}>
							{getFieldDecorator('phone', {
								rules: [{ required: true, message: '请输入电话号码!'},{max: 11, message: '最多输入11个字符'}],
								initialValue:modelTitle==='编辑大使'? labelPhone: ''
							})(
								<Input placeholder='请输入电话号码' />
							)}
						</Form.Item>
					</Form>
				</Modal>

        <Modal title="批量导入" className="batch-modal" width={800} visible={visibleUpload} maskClosable={false} onOk={this.submitOk} onCancel={this.offModal}>
          { showUpload === 'before'? // 上传
          <div className="modal-content">
            <Icon type="file-excel" className="file-icon" />
            <p>下载模版并完善信息后，可将文件在此处上传，支持xls、xlsx格式</p>
            <Button type="primary"  loading={iconLoading} className="my-button-primary upload-btns">
            <input type="file" className="upload-file" accept=".xlsx, .xls" onChange={this.uploadCardImgFront} />
            选择文件</Button>
          </div>
          :showUpload === 'reset'? // 导入、
          <div className="modal-content">
            {/* <Icon type="file-excel" className="file-icon upload-icon" />
            <p>{fileObj.name}</p>
            <Button type="primary" loading={iconLoading} onClick={ this.exportFile } className="my-button-primary export-rig">导入</Button>
            <Button onClick={this.resetChoose} >重新选择</Button> */}
						<p>{msgObj}</p>
						{ buttonList.some(item => item.perms === 'api:integral:exportFailList') ? <Button type="primary"  onClick={this.downerrfile} className="my-button-primary">下载错误列表</Button> : "" }
          </div>
					:showUpload === 'done'? //成功
          <div className="modal-content"> 
            <Button type="primary" onClick={this.offModal} className="my-button-primary">完成</Button>
          </div>:''
          }
          <a  style={{ color: '#277fff',cursor: 'pointer'}} href="https://kodo.1000phone.com/userlist.xls"  download>下载模版</a>
        </Modal>
			</div>
		)
	}
};

export default Form.create()(LabelManagement)